module.exports = __webpack_public_path__ + "static/img/syyBottomNew1.7cd3f21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/syyBottomNew1.png
// module id = KeiY
// module chunks = 0